import React from 'react';
import './Modal.scss';
import {connect} from 'react-redux';
import Button from '../../Button/Button';
import {Fade, Modal} from '@material-ui/core';
import Cancel from '../../../../assets/icons/Cancel';

const _Modal = ({
                   showModal,
                   handleClose,
                   handleClick,
                    modalTitle,
                   modalText,
                    modalButtonText,
                    modalContent,
               }) => {
        return (
            <Modal open={showModal} onClose={handleClose} closeAfterTransition>
                <Fade in={showModal} timeout={300}>
                    <div className={'v2-content-container'}>
                        <div className={'title'}>
                            <div onClick={handleClose} className={'cursor-pointer'}><Cancel/></div>
                        </div>
                        <div className={'content'}>
                        <div className='modal-body-container'>
                                <div className='modal-subtitle'>
                                    {modalTitle && <p className={'h3 v2-c-text-title'}>{modalTitle}</p>}
                                    {modalContent}
                                    {modalText && <p className={'body-1 c-text-subtitle'}>{modalText}</p>}
                                </div>
                            {modalButtonText &&
                                <Button size={'large'} onClick={handleClick}>
                                    {modalButtonText}
                                </Button>
                            }
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(_Modal);
